import { useContext } from 'react';
import { ApplicationContext } from './ApplicationProvider';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var LoadingComp = function () { var loading = useContext(ApplicationContext).loading; return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx("div", { id: "overlay", className: loading ? 'loading' : '' }) }); };
